<app-spinner [isLoading]="showLoader" minHeight="10rem" />
